module.exports = __webpack_public_path__ + "img/shape-14.b450823f.svg";